// Unsaved-changes bar fixed to the bottom of the screen (above the bottom navigation on a phone or a tablet), whatever the page length:
// `sticky` only sticks once the page scrolls, so on a short page the bar used to float in the middle of it. The spacer keeps
// the end of the page reachable above the bar.
export default function BottomActionBar({ children, className = "", ...props }) {
  return (
    <>
      <div className="h-20" aria-hidden="true" />
      <div className="fixed inset-x-0 bottom-[4.75rem] lg:bottom-4 z-30 px-4 lg:left-64 md:px-6" {...props}>
        <div className={`mx-auto max-w-5xl rounded-xl border border-slate-200 bg-white p-3 shadow-lg flex items-center gap-2 ${className}`}>
          {children}
        </div>
      </div>
    </>
  );
}
